<template>
		<div class="loadout-card-skill"
			:class="{ 'is-active': skill.isActive }"
			@click="toggleView"
		>
		<img :src="iconURL(skill.icon)" alt="">
		<div class="skill-info-container">
			<transition name="fade-fast">
				<div v-if="currentView === 'label'" class="skill-label">{{ label }}</div>
				<div v-else-if="currentView === 'combo'" class="requirement" :class="skill._model.def.type">
					<template v-if="skill._model.def.type == 'character'">
						<span>{{ skill._model.requirement }}</span>
					</template>
					<template v-else>
						<img v-for="letter in skill._model.requirement?.toString" :key="letter"
							:src="getTypeImg(letter)"
						>
					</template>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
const TYPES_LABEL_SRCS = {
	0: '/6/66/Card_Red.png',
	1: '/0/0e/Card_Yellow.png',
	2: '/1/13/Card_Blue.png',
	3: '/6/6c/Card_Green.png'
};

export default {
	name: 'loadout-card-skill',
	props: {
		skill: {
			type: Object,
			required: true
		},
		view: {
			type: String,
			default: 'label'
		}
	},
	data() {
		return {
			currentView: this.view
		};
	},
	computed: {
		label() {
			return `${this.skill.name} ${'I'.repeat(this.skill.level)}`;
		}
	},
	watch: {
		view(viewName) {
			this.currentView = viewName;
		}
	},
	methods: {
		iconURL(pathToIcon) {
			return `https://static.wikia.nocookie.net/rockman_x_dive/images${pathToIcon}`;
		},
		getTypeImg(type) {
			if (typeof(type) == 'string')
				type = 'RYBG'.indexOf(type);
			return this.iconURL(TYPES_LABEL_SRCS[type]);
		},
		toggleView() {
			this.currentView = this.currentView === 'label' ? 'combo' : 'label';
		}
	}
};
</script>

<style lang="scss">

.loadout-card-skill {
	display: flex;
	width: 100%;
	height: calc(50%);
	padding: 2px;
	padding-left: 0;
	>img {
		height: 100%;
	}
	.skill-info-container {
		flex: auto;
		font-size: 12px;
		background: #424242;
		color: white;
		display: flex;
		align-items: center;
		box-shadow: inset 2px 2px 4px #0009;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		overflow: hidden;
		position: relative;
		.skill-label {
			padding: 0 10px;
			@media (max-width: 399px) {
				padding: 0 2px;
			}
		}
		.requirement {
			width: 100%;
			&.common {
				display: flex;
				justify-content: center;
				>img {
					width: 25px;
					@media (max-width: 360px) {
						width: 20px;
					}
				}
			}
			&.character {
				text-align: center;
			}
		}
	}
	&:not(.is-active) {
		filter: brightness(0.5);
	}

	.fade-fast-enter-active,
	.fade-fast-leave-active {
		transition: opacity 0.2s ease;
		position: absolute;
		// width: calc(100% - 20px) !important;
	}

	.fade-fast-enter-from,
	.fade-fast-leave-to {
		opacity: 0;
	}

	@media (prefers-reduced-motion: reduce) {
		.fade-fast-enter-active,
		.fade-fast-leave-active {
			transition: none;
		}
	}
}

</style>
